'use strict';

var ParamsViewport = function ParamsViewport(containerWidth, containerHeight) {
  var padding = {
    top: 5,
    bottom: 22,
    left: 60,
    right: 10
  };
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    maxGroupWidth: 20,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    xGapSize: 10,
    xDataSize: 10,
    xBarPadding: 1,
    isSparse: true
  };
};
module.exports = ParamsViewport;